import { BaseContainerModel } from "../base-container.model";
import {
  bl_mkp_mst_item_hdr_Rowinterface,
  bl_mkp_mst_item_hdr_Rowclass,
} from "../../dbschema/index";

export class SellerPanelContainerModel extends BaseContainerModel {
  bl_mkp_mst_item_hdr: bl_mkp_mst_item_hdr_Rowinterface =
    new bl_mkp_mst_item_hdr_Rowclass();
} 
